import styled from '@emotion/styled'

export const StyledDiv = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: '90px'
}))

export const ChartWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'chartWidth' && prop !== 'chartHeight'
})(({chartWidth, chartHeight}) => ({
  width: chartWidth,
  height: chartHeight
}))
